import { create } from 'zustand';
import { projectApi } from '../services/api';
import type { Project } from '../types';

interface ProjectState {
  projects: Project[];
  loading: boolean;
  error: string | null;

  fetchProjects: () => Promise<void>;
  createProject: (data: Partial<Project>) => Promise<Project>;
  updateProject: (id: string, data: Partial<Project>) => Promise<Project>;
  deleteProject: (id: string) => Promise<void>;
}

export const useProjectStore = create<ProjectState>((set) => ({
  projects: [],
  loading: false,
  error: null,

  fetchProjects: async () => {
    set({ loading: true, error: null });
    try {
      const projects = await projectApi.list();
      set({ projects, loading: false });
    } catch (err: any) {
      set({ error: err.message, loading: false });
    }
  },

  createProject: async (data) => {
    const project = await projectApi.create(data);
    set((s) => ({ projects: [...s.projects, project] }));
    return project;
  },

  updateProject: async (id, data) => {
    const updated = await projectApi.update(id, data);
    set((s) => ({
      projects: s.projects.map((p) => (p._id === id ? { ...p, ...updated } : p)),
    }));
    return updated;
  },

  deleteProject: async (id) => {
    await projectApi.delete(id);
    set((s) => ({ projects: s.projects.filter((p) => p._id !== id) }));
  },
}));
